<template>
    <div id="attribute-context">
        <a-auto-complete
            @select="$emit('selected', selected)"
            v-model="selected"
            :placeholder="$t('chatbotv2.choseAttribute')"
            :dataSource="dataSource"
            style="width: 100%"
            @search="(x) => (this.query = x)"
        />
    </div>
</template>

<script>
import { Attributes, BoardAttributes } from "../../palatteEnums";

export default {
    name: "AttributesContext",
    props: {
        value: String,
        isStory: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dataSource() {
            let _attributes = this.isStory ? BoardAttributes : Attributes;
            var paletteKeyPrefix = "auto.chatbotPalette.";
            const toListObj = (data) => data.map((x) => ({ text: this.$t(paletteKeyPrefix + x), value: x }));
            if (!!this.query) {
                let regx = new RegExp(this.query.toLowerCase(), "gi");
                return toListObj(_attributes.filter((x) => regx.test(x.toLowerCase())));
            }
            return toListObj(_attributes);
        },
    },
    data() {
        return {
            query: "",
            selected: null,
        };
    },
    mounted() {
        if (!!this.value) this.selected = this.value;
    },
    watch: {
        selected(nV, oV) {
            this.$emit("input", nV);
        },
    },
};
</script>

<style lang="scss" scoped>
#attribute-context {
    width: 100%;
    margin-top: 10px;
}
</style>
